import React from "react";
import PropTypes from "prop-types";

const TitleBlock = props => {
  const { title, className } = props;
  return (
    <div className={`${className} nw-titlestrip-wrapper`}>
      <span className={`${className} nw-titlestrip-content`}>{title}</span>
    </div>
  );
};

TitleBlock.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: TitleBlock,
  component: TitleBlock,
};

export default ProjectComponent;
